import { render, staticRenderFns } from "./PermissionsUsersForm.vue?vue&type=template&id=416e586f&scoped=true&"
import script from "./PermissionsUsersForm.vue?vue&type=script&lang=js&"
export * from "./PermissionsUsersForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "416e586f",
  null
  
)

export default component.exports